var render = function render(){var _vm=this,_c=_vm._self._c;return _c('mainHeader',{attrs:{"isMobile":_vm.isMobile,"screenWidth":_vm.screenWidth}})
}
var staticRenderFns = []

export { render, staticRenderFns }